// extracted by mini-css-extract-plugin
export var readonly = "_g8-1";
export var star = "_g8-0";